import { IEventSponsorship } from 'src/commons';
import { EventSponsorshipActionTypes, EventSponsorshipActions } from './event-sponsorship.actions';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: IEventSponsorship | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: EventSponsorshipActions): State {
    switch (action.type) {

        case EventSponsorshipActionTypes.LoadEventSponsorshipState: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case EventSponsorshipActionTypes.LoadEventSponsorshipStateSuccess: {
            return {
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case EventSponsorshipActionTypes.LoadEventSponsorshipStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case EventSponsorshipActionTypes.EventSponsorshipScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        case EventSponsorshipActionTypes.LoadInitialState: {
            return initialState;
        }

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;